import { ItfNewsItem } from './type';

export const transformData = (items: any[], tagUrl: string): ItfNewsItem[] => {
    const arr: ItfNewsItem[] = [];
    if (Array.isArray(items)) {
        items?.forEach((item: any) => {
            const obj = {} as ItfNewsItem;
            if (tagUrl) {
                const tagTarget = item?.blogTagList?.find((list: any) => list?.tagUrl === tagUrl);
                obj.tag = tagTarget?.tag || '';
            } else {
                obj.tag = item?.blogTagList?.[0]?.tag || '';
            }
            obj.href = item?.seoUrl || '';
            obj.date = item?.firstReleaseTime?.split(' ')?.[0]?.replaceAll('-', '/');
            const thePage = JSON.parse(item?.thePage || '{}');
            obj.title = thePage?.blogTitle || '';
            obj.pc = thePage?.blogImgPc || '';
            obj.h5 = thePage?.blogImgH5 || thePage?.blogImgPc || '';
            arr.push(obj);
        });
    }
    return arr;
};
